import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import useDataEvents from '../../dataHooks/useDataEvents'
import { LoadingIcon } from '@prosolve/common-components-ui'
import useSnackbar from '../../hooks/useSnackbar'
import useForm from '../../hooks/useForm';
import { FormField, Button } from '@prosolve/common-components-ui'
import useDataAttendees from "../../dataHooks/useDataAttendees";
import { getClientSubdomain } from '../../utils'

export default () => {
  const clientSubdomain = getClientSubdomain()
      
  const isStarSubdomain = (clientSubdomain === 'star')

  const { shareCode = '' } = useParams();

  const [ ...codeArray ] = shareCode;
  // Remove first destinationChar which is unused in our logic
  codeArray.shift()
  const code = codeArray.join('');

  const [isLoading, setIsLoading] = useState(true)

  const [eventId, setEventId] = useState()

  const [isSubmissionSuccess, setIsSubmissionSuccess] = useState(false)

  const { addNewAttendee } = useDataAttendees()

  const requiredFields = ['name', 'email']
  const optionalFields = []
  if (isStarSubdomain) {
    requiredFields.push('district')
    optionalFields.push('date')
  }

  const formSchema = {
    requiredFields,
    optionalFields,
    initData: {}
  };
  
  const formData = useForm(formSchema)

  const { fetchEventIdByCode } = useDataEvents();

  const snackbar = useSnackbar()

  const showError = (message) => {
    snackbar.newMessage({ message, severity: 'failure' })
  }

  const fetchEventData = async (code) => {
    setIsLoading(true)
    try {
      const eventData = await fetchEventIdByCode(code) || {}

      const { eventId = '' } = eventData;

      setEventId(eventId)
    } catch (e) {
      console.log(e)
      showError('Error occured')
    }
    setIsLoading(false)
  }

  useEffect(() => {
    if (code) {
      fetchEventData(code)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [code])


  const onClickSubmit = async () => {
    if (!isLoading && formData.isValid()) {
      setIsLoading(true)

      try {
        await addNewAttendee({ eventId, ...formData.values })

        setIsSubmissionSuccess(true)
      } catch (e) {
        console.log(e)
        showError(e)
      }
      setIsLoading(false)
    }
  }

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      marginTop: '50px'
    }}>
      {
        isLoading
          ?
          <LoadingIcon />
          : isSubmissionSuccess
            ?
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              rowGap: '15px',
              textAlign: 'center'
            }}>
              <div style={{ fontWeight: 'bold', fontSize: '32px'}}>{'Thank You!'}</div>
              <div style={{ marginTop: '50px', fontSize: '32px'}}>{'You have successfully submitted your attendence!'}</div>

              <div style={{ marginTop: '50px', fontSize: '20px' }}>{'You may now close this window.'}</div>
            </div>
            :
            Boolean(eventId) ?
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                rowGap: '15px',
                width: '50%'
              }}>
                <div style={{
                  display: 'flex'
                }}>
                  <FormField
                    style={{ flex: 1 }}
                    fieldId='name'
                    type='text'
                    label='Full Name'
                    placeholder='e.g. John Smith'
                    formData={formData}
                  />
                </div>
                <div style={{
                  display: 'flex'
                }}>
                  <FormField
                    style={{ flex: 1 }}
                    fieldId='email'
                    type='text'
                    label={isStarSubdomain ? 'School Email' : 'Email'}
                    placeholder='e.g. jsmith@gmail.com'
                    formData={formData}
                  />
                </div>
                {
                  isStarSubdomain &&
                  <div style={{
                    display: 'flex'
                  }}>
                    <FormField
                      style={{ flex: 1 }}
                      fieldId='date'
                      type='date'
                      label='Date'
                      placeholder=''
                      formData={formData}
                    />
                  </div>
                }
                {
                  isStarSubdomain &&
                  <div style={{
                    display: 'flex'
                  }}>
                    <FormField
                      style={{ flex: 1 }}
                      fieldId='district'
                      type='text'
                      label='District'
                      placeholder=''
                      formData={formData}
                    />
                  </div>
                }
                <div style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'center',
                  columnGap: '10px',
                  padding: '10px'
                }}>
                  <Button onClick={onClickSubmit} $colored={true} $disabled={isLoading}>
                    {'Submit'}
                  </Button>
                </div>
              </div>
              :
              <div>
                {'Unable to find associated event'}
              </div>
      }
    </div>
  )
}